/*eslint no-console: ["error", { allow: ["warn", "log"] }] */

import rafthrottle from './util/raf-throttle';
import autocomplete from './lib/search/autocomplete';
import searchfilter from './lib/search/searchfilter';
import crisearch from './lib/search/cri';
import vptsearch from './lib/search/vpt';
import atlsearch from './lib/search/atl';
import faqssearch from './lib/search/faqs';
import sstsearch from './lib/search/sst';
import inquirysearch from './lib/search/inquiry';
import contentSelector from './lib/components/content-selector';
import tabs from './lib/tabs';
import layoutSize from './lib/layoutSize';
import {loadTwigExtensions} from "./lib/twig/twig";
import $ from 'jquery';
import 'select2';
import 'object-assign-polyfill';
import {setDefaultAltText} from "./lib/dom/images";
import {openDocumentsInNewTab, openExternalLinksInNewTab} from "./lib/dom/links";

document.addEventListener("DOMContentLoaded", () => {

  const $headerSearch = $('.header__search');
  $headerSearch.on('mouseenter', () => {
    $('.component__search-field--header').focus();
  });

  $headerSearch.on('focus', () => {
    $('.component__search-field--header').focus();
  });

  $headerSearch.on('focusin', () => {
    $headerSearch.addClass('hover');
  });

  $headerSearch.on('focusout', () => {
    $headerSearch.removeClass('hover');
  });

  $('h2.collapsible').each(function() {
    $(this)
        .nextUntil('h2.collapsible,footer')
        .wrapAll('<div class="collapsible-content"></div>');
    $(this).on('click', () => {
      $(this).toggleClass('collapsible--open');
    });
  });

  $('[data-navigation-toggle]').on('click', () => {
    $('[data-navigation]').toggleClass('navigation--open')
  });

  $('[data-accordion-trigger]').on('click', function() {
    $(`[data-accordion-section=${$(this).data('accordion-trigger')}]`).toggleClass('accordion--open');
  });


  $('[data-track-scroll-shadows]').each(function () {
    rafthrottle('scroll', 'rafscroll', this);
  });

  const trackScrollShadow = function () {
    const amountToScroll = this.scrollHeight - this.clientHeight;

    const scrollPosition = amountToScroll ? this.scrollTop / amountToScroll : 'false';
    const container = $(this).parent();
    container.attr('data-track-scroll-position', scrollPosition);
  };

  $('[data-track-scroll-shadows]').on('rafscroll', trackScrollShadow);
  $(window).on('resize', () => $('[data-track-scroll-shadows]').trigger('rafscroll'));

  loadTwigExtensions();

  if ($('[data-autocomplete]').length) {
    autocomplete();
  }

  if ($('[data-search-filter]').length) {
    searchfilter();
  }

  if ($('[data-form-filters="cri-table"]').length) {
    crisearch();
  }

  if ($('[data-form-filters="inquiry-table"]').length) {
    inquirysearch();
  }

  if ($('[data-form-filters="vpt-table"]').length) {
    vptsearch();
  }

  if ($('[data-form-filters="atl-table"]').length) {
    atlsearch();
  }

  if ($('[data-form-filters="faqs-table"]').length) {
    faqssearch();
  }

  if ($('[data-form-filters="sst-list"]').length) {
    sstsearch();
  }

  if ($('[data-content-selector]').length) {
    contentSelector();
  }

  $(document).on('nfFormReady', function() {
    $('select.nf-element').select2({closeOnSelect:true}).on('select2:open', function(){
      $('.select2-search__field').attr('placeholder', 'Type to search');
    });
  });

  tabs();
  layoutSize();

  // Make documents open in new tab
  openDocumentsInNewTab();

  // Make External links open in new tab
  openExternalLinksInNewTab();

  // Set default alt text for image
  setDefaultAltText();
});



// WEBPACK FOOTER //
// ./scripts/main.js